import React from "react";
import Markdown from "markdown-to-jsx";

function SafeLink({children, href, ...props}) {
    const safeHref = /^(https?:|mailto:|\/|#)/i.test(String(href || "")) ? href : undefined;
    return <a {...props} href={safeHref} target="_blank" rel="noreferrer noopener">{children}</a>;
}

function ResponsiveTable({children, ...props}) {
    return (
        <div className="overflow-x-auto my-2">
            <table {...props}>{children}</table>
        </div>
    );
}

function AiMarkdownMessage({content}) {
    return (
        <Markdown
            className="ai-markdown text-xs line-height-3"
            options={{
                disableParsingRawHTML: true,
                forceWrapper: true,
                wrapper: "div",
                overrides: {
                    a: {component: SafeLink},
                    table: {component: ResponsiveTable},
                },
            }}
        >
            {String(content || "")}
        </Markdown>
    );
}

export default AiMarkdownMessage;
